import { createStateSelectorHook } from 'src/lib/sweetState';
import { BrandVoicesStore, FreestyleToolsStore } from 'src/store';
import { LocalStore } from 'src/views/ProjectDocumentView/views/CanvasProject/store'; // TODO: refactor to not use this other-view store (if possible)

const useFreestyleToolsState = createStateSelectorHook(FreestyleToolsStore, [
  'savingFreestyleTool',
  'currentFreestyleTool',
  'errors',
]);
const useBrandVoicesState = createStateSelectorHook(BrandVoicesStore, [
  'brandVoicesAssets',
  'loadingBrandVoiceAssets',
]);
const useLocalState = createStateSelectorHook(LocalStore, [
  'generationTool',
  'messagingBank',
  'currentUrls',
]);

export function useViewState() {
  const freestyleToolsState = useFreestyleToolsState();
  const brandVoicesState = useBrandVoicesState();
  const localState = useLocalState();

  return {
    ...freestyleToolsState,
    ...brandVoicesState,
    ...localState,
  };
}
